import { Component, computed, HostListener, input, OnInit, signal } from '@angular/core';
import { PostCode } from '../../../global/postcode';
import { Breakpoints } from '../../types/breakpoints';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-telephone-link',
  imports: [ButtonComponent],
  standalone: true,
  templateUrl: './telephone-link.component.html',
  styleUrl: './telephone-link.component.scss',
})
export class TelephoneLinkComponent implements OnInit {
  phoneNumber = input.required<string | undefined>();
  useButtonOnMobile = input(false);
  buttonLabel = input<string | undefined>(undefined);
  largeFont = input(false);

  postCode = input<string | undefined>(undefined);
  postCodeMessaging = signal<string | undefined>(undefined);
  hidePostCodeMessaging = input(false);
  postCodeMessagingClasses = input<string | undefined>(undefined);
  buttonStyleOptions = input<{ variant: string; fill: boolean }>({
    variant: '',
    fill: false,
  });

  private viewModel = computed(() => {
    this.getPostCodeMessaging(this.postCode());
    return {
      phoneNumber: this.phoneNumber(),
      sanitizedPhoneNumber: (this.phoneNumber() ?? '').replace(/ /g, ''),
      useButtonOnMobile: this.isMobile() && this.useButtonOnMobile(),
      buttonLabel: this.buttonLabel(),
      largeFont: this.largeFont(),
      hidePostCodeMessaging: this.hidePostCodeMessaging(),
    };
  });

  get vm() {
    return this.viewModel();
  }

  isMobile = signal(false);

  @HostListener('window:resize')
  onResize() {
    const isMobile = window.innerWidth < Breakpoints.sm;
    if (this.isMobile() !== isMobile) {
      this.isMobile.set(isMobile);
    }
  }

  ngOnInit() {
    this.onResize();
  }

  getPostCodeMessaging(postCode: string | undefined) {
    if (!postCode) return;
    PostCode.getCallCostMessagingForPostCode(postCode).subscribe({
      next: (value) => {
        this.postCodeMessaging.set(value);
      },
    });
  }
}
